/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context("../images", true);
const imagePath = (name) => images(name, true);

import { v4 as uuidv4 } from "uuid";

const getCookie = (name) => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? match.split("=")[1] : null;
};

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  document.cookie = `${name}=${value}; path=/; expires=${date.toUTCString()}`;
};

const syncVisitorID = () => {
  let cookieID = getCookie("XVisitorID");
  let localID = localStorage.getItem("XVisitorID");

  // If both exist and are different, prefer cookie and sync to localStorage
  if (cookieID && localID && cookieID !== localID) {
    localStorage.setItem("XVisitorID", cookieID);
    localID = cookieID;
  }

  // If only one exists, sync to the other
  if (cookieID && !localID) {
    localStorage.setItem("XVisitorID", cookieID);
    localID = cookieID;
  } else if (!cookieID && localID) {
    setCookie("XVisitorID", localID, 365);
    cookieID = localID;
  }

  // If neither exists, generate and sync both
  if (!cookieID && !localID) {
    const fingerprint = uuidv4();
    setCookie("XVisitorID", fingerprint, 365);
    localStorage.setItem("XVisitorID", fingerprint);
    return fingerprint;
  }

  return cookieID || localID;
};

(async () => {
  const currentVisitorID = syncVisitorID();
  console.log("Current Visitor ID:", currentVisitorID);
})();

const jQuery = require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

require("jquery-migrate");

import { Turbo } from "@hotwired/turbo-rails";
window.Turbo = Turbo;

import SimpleBar from "simplebar";
global.SimpleBar = SimpleBar;
window.SimpleBar = SimpleBar;

const tIppy = require("tippy.js").default;
global.tippy = tIppy;
window.tippy = tIppy;

const cLipboard = require("clipboard");
global.ClipboardJS = cLipboard;
window.ClipboardJS = cLipboard;

const snackBar = require("../src/theme/snackbar");
global.Snackbar = snackBar;
window.Snackbar = snackBar;

require("../src/theme/report-validity");
require("../src/theme/mmenu.min");
require("../src/theme/bootstrap-slider.min");
require("../src/theme/bootstrap-select.min");
require("../src/theme/waypoint");
require("../src/theme/counterup.min");
require("../src/theme/magnific-popup.min");
require("../src/theme/slick.min");
require("../src/theme/custom");
require("../src/theme/leaflet.min.js");
require("../src/theme/leaflet-markercluster.min.js");
require("../src/theme/leaflet-gesture-handling.min.js");
require("../src/theme/leaflet-hireo.js");

import ReactOnRails from "react-on-rails";
import JobSearch from "../bundles/JobSearch";

ReactOnRails.register({
  JobSearch,
});
